import { useState, useRef } from 'react';

const FileUploadButton = ({ folio, tipoDocumento, label, onUploadSuccess, isRequired, numeroOC, numFac, nmInsumo }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      setError('Solo se permiten archivos PDF');
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      setError('El archivo no debe exceder 5MB');
      return;
    }

    await uploadFile(file);
  };

  const uploadFile = async (file) => {
    setUploading(true);
    setError(null);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append('archivo', file);
    formData.append('folio', folio);
    formData.append('tipoDocumento', tipoDocumento);
    if (numeroOC) formData.append('numeroOC', numeroOC);
    if (numFac) formData.append('numFac', numFac);
    if (nmInsumo) formData.append('nmInsumo', nmInsumo);

    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/documentos/subir`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Error al subir archivo');
      }

      const result = await response.json();
      setUploadedFile({
        nombreArchivo: result.nombreArchivo,
        tipoDocumento: result.tipoDocumento
      });
      setUploadProgress(100);

      if (onUploadSuccess) {
        onUploadSuccess(result);
      }
    } catch (err) {
      setError(err.message);
      console.error('Error al subir archivo:', err);
    } finally {
      setUploading(false);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="file-upload-container">
      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf"
        onChange={handleFileChange}
        style={{ display: 'none' }}
        disabled={uploading}
      />
      <button
        type="button"
        onClick={handleClick}
        disabled={uploading}
        className={`upload-button ${uploadedFile ? 'success' : ''} ${isRequired ? 'required' : ''}`}
      >
        {uploading ? `Subiendo... ${uploadProgress}%` : uploadedFile ? 'Archivo subido' : label}
      </button>
      {uploadedFile && (
        <span className="file-name">{uploadedFile.nombreArchivo}</span>
      )}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default FileUploadButton;
